import { SVGAttributes } from "react";

export default function HelpButtonShape(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="108"
      height="95"
      fill="none"
      {...props}
      viewBox="0 0 108 123"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37 4C28.7157 4 22 10.7157 22 19V29.9546C11 39.1264 4 52.9332 4 68.375C4 95.9892 26.3858 118.375 54 118.375C81.6142 118.375 104 95.9892 104 68.375C104 53.1094 97.1588 39.4417 86.375 30.2704V19C86.375 10.7157 79.6593 4 71.375 4H37Z"
        fill="white"
      />
    </svg>
  );
}
